import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    IconButton,
    Chip,
    Divider,
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import StarIcon from '@mui/icons-material/Star';

function MitgliederTab({ mitglieder, isErsteller, onInviteOpen, onRemove }) {
    return (
        <>
            {isErsteller && (
                <Button
                    variant="contained"
                    startIcon={<PersonAddIcon />}
                    onClick={onInviteOpen}
                    sx={{ mb: 2 }}
                >
                    Mitglied einladen
                </Button>
            )}
            <Card>
                <CardContent>
                    <List>
                        {mitglieder.map((mitglied, index) => (
                            <Box key={mitglied.id}>
                                {index > 0 && <Divider />}
                                <ListItem
                                    secondaryAction={
                                        isErsteller && !mitglied.ist_ersteller && (
                                            <IconButton
                                                edge="end"
                                                onClick={() => onRemove(mitglied.id, `${mitglied.vname} ${mitglied.nname}`)}
                                                color="error"
                                            >
                                                <PersonRemoveIcon />
                                            </IconButton>
                                        )
                                    }
                                >
                                    <ListItemAvatar>
                                        <Avatar sx={{ bgcolor: 'primary.main' }}>
                                            {mitglied.vname.charAt(0)}
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <Typography variant="body1">
                                                    {mitglied.vname} {mitglied.nname}
                                                </Typography>
                                                {mitglied.ist_ersteller && (
                                                    <Chip icon={<StarIcon />} label="Ersteller" size="small" color="primary" />
                                                )}
                                            </Box>
                                        }
                                        secondary={
                                            <Box component="span">
                                                <Box component="span" display="block" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
                                                    Beigetreten: {new Date(mitglied.beigetreten_am).toLocaleDateString('de-DE')}
                                                </Box>
                                            </Box>
                                        }
                                    />
                                </ListItem>
                            </Box>
                        ))}
                    </List>
                </CardContent>
            </Card>
        </>
    );
}

export default MitgliederTab;
